var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulletPointer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02287 4.92628L9.02211 4.92583L5.67804 2.95949L5.67684 2.95878L2.33277 0.979842L2.33233 0.979583C1.50141 0.489007 0.5 1.11243 0.5 2.04691V9.95291C0.5 10.8874 1.50141 11.5108 2.33233 11.0202L2.33277 11.02L9.02287 7.06093C9.02293 7.0609 9.02298 7.06087 9.02304 7.06084C9.83114 6.58357 9.83109 5.40345 9.02287 4.92628Z",
    fill: "#FF988A",
    stroke: "#FF988A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletPointer);
export default __webpack_public_path__ + "static/media/bulletPointer.b96f93e9af00e9a9634f4b8b80412e2f.svg";
export { ForwardRef as ReactComponent };